
let sySite = 'http://bi-dev.internal.singleronbio.com/';
if(process.env.VUE_APP_NODE_TEST === 'production') {
    sySite = 'https://www.synecosys.cn/';
} else if(process.env.VUE_APP_NODE_TEST === 'awsproduction') {
    sySite = 'https://www.synecosys.com/';
} else if(process.env.VUE_APP_NODE_TEST === 'stage') {
    sySite = 'http://bi-alpha.internal.singleronbio.com/';
}
export const homeMenuList = [{
    active: true,
    id: 'CeleLensCloudPlatform',
    name: 'Product.Menu.text2',
    routePath: '',
    children: [{
        active: false,
        id: 'SynEcoSysDatabase',
        name: 'Product.Menu.text1',
        routePath: sySite,
    },{
        active: false,
        id: 'CeleLensCloudPlatform',
        name: 'Product.Menu.text2',
        routePath: '',
    }],
},{
    active: false,
    id: 'aboutUs',
    name: 'Product.Menu.text3',
    routePath: 'https://singleron.bio/about/list-5.html',
    flag: true,
}];
export const windowRouterPath = {
    SynEcoSysDatabase: sySite,
};


export const mainMenuListCNUS = {
    'My Analyzes': 'Menu.List.My Analyzes',
    Tools: 'Menu.List.My.Tools',
    'Import data': 'Menu.List.Import.Data',

    'Intergrate data': 'Menu.List.Integrate.Data',
    "Integrate local data": 'Menu.List.Integrate.Local.Data',
    "Integrate SynEcoSys data": 'Menu.List.Integrate.SynEcoSys.Data',
    "Integrate local and Integrate SynEcoSys data": 'Menu.List.Integrate.Local.SynEcoSys.Data',

    'Bulk local data': 'Menu.List.Bulk.Local.Data',
    Resource: 'Menu.List.Resource',
    TutorialVideos: 'Menu.List.TutorialVideos',
    Documentation: 'Menu.List.Documentation',
    GuideBook: 'Menu.List.GuideBook',
    FAQ: 'Menu.List.FAQ',
    Contact: 'Menu.List.Contact',

    "My account": 'Menu.List.My.Account',
    'Requested downloads': 'Menu.List.Requested.Downloads',
    Notifications: 'Menu.List.Notifications',
    'Groups setting': 'Menu.List.Groups.Setting',
    'Account info': 'Menu.List.Account.Info',
};